<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <UserMasterForm
        ref="userForm"
        v-model="userFormModel"
        label-width="10em"
        formMode="edit"
        :autocomplete-user-id-set="autocompleteUserIdSet"
        :autocomplete-user-name-set="autocompleteUserNameSet"
        :programName="programName"
      />
    </template>
    <template #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import UserMasterForm from '@/components/organisms/dialog/master/UserMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import UserAutocompleteLoader from '@/mixins/UserAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    UserMasterForm,
    EditDialogFooter
  },
  mixins: [
    UserAutocompleteLoader
  ],
  props: {
    autocompleteUserIdSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteUserNameSet: {
      type: Array,
      default: () => ([])
    },
    // customerCodeSet: Array,
    // phoneNumberSet: Array,
    // emailSet: Array,
    // roleIDSet: Array,
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    programName: {
      type: String,
      default: 'UserMasterPage'
    },
    visible: Boolean
  },
  data () {
    return {
      userFormModel: {
        user_id: undefined,
        user_name: undefined,
        customer_code: undefined,
        phone_number: undefined,
        email: undefined,
        role_id: undefined,
        login_user_id: undefined,
        change_password: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {},
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()

      // const params = { ...this.userFormModel }
      // params.login_user_id = this.$loginuser.get('username')
      // if (params.change_password) {
      //   // params.password = this.getTemporaryPassword()
      //   params.password = 'p@ssw0rd'
      // }

      this.$refs.userForm.validate()
        .then((valid) => {
          // return this.$axios.put('/user', params)
          return this.$axios.put('/user', this.userFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          if (this.programName !== 'UserInformation') {
            // this.margeUserNameSet(this.userFormModel.user_name)
            this.$emit('refresh')
          } else {
            this.$loadingMask.off()
          }
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['user_id', 'user_name']
      this.$nextTick(() => {
        this.$refs.userForm.clearFields()
        Object.keys(this.userFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.userFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
